import React from 'react';
import { Box } from '@mui/material';
import styled, { css } from 'styled-components';

import { Button, IconGraphy } from '@leapeasy/ui-kit';
import { DemoModeToggle } from './DemoModeToggle';

const ProfileView = ({
  setInvisible,
  setEditDialogOpen,
  onRequestLogout,
  name = 'Bobby',
  title = 'admin',
  email = 'bobby@leapeasy.com',
  phone_number = '323 232 3232',
}) => {
  return (
    <React.Fragment>
      <BackgroundDiv onClick={() => setInvisible(null)} />
      <ProfilePanel>
        <Arrow />
        <Text1>{name}</Text1>
        <Text2>{title}</Text2>

        <Separator />

        <DemoModeToggle variant="profile" />

        <ContactInfo>
          <Box>
            <IconGraphy icon="Notifications.Email" width="14px" />
          </Box>

          <Box>
            <p>Email Address</p>
            <p>{email}</p>
          </Box>
        </ContactInfo>

        <ContactInfo>
          <Box>
            <IconGraphy icon="MediaDevices.Call" width="14px" />
          </Box>

          <Box>
            <p>Phone Number</p>
            <p>{phone_number}</p>
          </Box>
        </ContactInfo>

        <PrimaryActionButton
          variant="primary"
          size="medium"
          onClick={() => {
            setInvisible(null);
            setEditDialogOpen(true);
          }}
        >
          Edit Profile
        </PrimaryActionButton>

        <SecondaryActionButton
          variant="tertiary"
          size="medium"
          onClick={() => {
            setInvisible(null);
            onRequestLogout?.();
          }}
        >
          Logout
        </SecondaryActionButton>
      </ProfilePanel>
    </React.Fragment>
  );
};

export default ProfileView;

const TextStyle = css`
  font-family: Inter;
  font-style: normal;
  line-height: 165%; /* 23.1px */
  letter-spacing: -0.14px;
  margin: 0;
  font-weight: 600;
`;

const Text1 = styled.p`
  ${TextStyle}
  font-size: 14px;
  letter-spacing: -0.14px;
  color: #242225;
`;

const Text2 = styled.p`
  ${TextStyle}
  font-size: 12px;
  color: #7e3080;
`;

const Separator = styled.div`
  width: 100%;
  margin: 16px 0;
  height: 1px;
  background-color: #f8f4f9;
`;

const ContactInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;

  & > div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #f8f4f9;
    padding: 14px;

    & > svg {
      color: #7e3080;
      width: 20px;
      height: 20px;
    }
  }

  & > div:nth-child(2) {
    flex: 1;
    p {
      margin: 0;
      font-family: Inter;
    }
    & > p:nth-child(1) {
      color: #a39aa9;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 165%;
    }

    & > p:nth-child(2) {
      color: #242225;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 165%; /* 23.1px */
      letter-spacing: -0.14px;
    }
  }
`;

const BackgroundDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
`;

const Arrow = styled.div`
  position: absolute;
  top: -7px;
  right: 56px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
  transform: rotate(45deg);
`;

const ProfilePanel = styled(Box)`
  position: absolute;
  top: 64px;
  right: 32px;
  border: 1px solid #f3f3f3;
  width: min(294px, calc(100vw - 24px));
  border-radius: 8px;
  padding: 16px;
  box-shadow:
    0px 16px 32px -4px rgba(90, 94, 107, 0.04),
    0px 2px 4px 0px rgba(90, 94, 107, 0.08);
  background-color: #fff;
  z-index: 1001;
`;

const PrimaryActionButton = styled(Button)`
  width: 100%;
  min-height: 40px;
`;

const SecondaryActionButton = styled(Button)`
  width: 100%;
  min-height: 40px;
  margin-top: 12px;
  background: #f8f4f9;
  border: none;
  color: #90388b;
`;
